export const LANGUAGES = ['pt-BR', 'en', 'es'] as const;

export type Language = (typeof LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<Language, string> = {
  'pt-BR': 'PT',
  en: 'EN',
  es: 'ES',
};

export const DEFAULT_LANGUAGE: Language = 'pt-BR';

import { PT_BR } from './messages.pt-BR';

/** The default locale is the only one in the entry chunk; en and es are
 *  fetched on demand by the i18n store. Everything falls back to this table,
 *  so it must always be present. */
export const MESSAGES_PT_BR = PT_BR;

export type MessageKey = keyof typeof PT_BR;

/** Locale tables other than the default are code-split. */
export async function loadMessages(language: Language): Promise<Record<MessageKey, string>> {
  if (language === 'en') return (await import('./messages.en')).default;
  if (language === 'es') return (await import('./messages.es')).default;
  return PT_BR as unknown as Record<MessageKey, string>;
}

export function normalizeLanguage(value: string | null | undefined): Language {
  if (value === 'en' || value === 'es' || value === 'pt-BR') return value;
  if (value?.toLowerCase().startsWith('en')) return 'en';
  if (value?.toLowerCase().startsWith('es')) return 'es';
  return DEFAULT_LANGUAGE;
}
